// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_5f4d4bfd","outerContainer":"_44cb57ba","secondaryToolbar":"_5d8058d5","doorHangerRight":"_19fcc62e","toolbarContainer":"e8b53dda","toolbarViewerMiddle":"_47ce0fc1","progressBar":"c54db4e6","back-to-application":"_85d92bfb","root":"bb1c4480","fullScreenMode":"b9d5848c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/Notifications/styles.styl
// module id = 5162
// module chunks = 39